import { defineComponent as _defineComponent } from 'vue';
import { SButton } from '@strana-artw/ui-kit';
import { defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'SuccessRequest',
  props: {
    title: {
      type: String,
      default: undefined
    },
    subTitle: {
      type: String,
      default: undefined
    },
    buttonLabel: {
      type: String,
      default: 'Отлично'
    }
  },
  emits: ["closed"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    defineComponent({
      name: 'SuccessRequest'
    });
    function handleClose() {
      emit('closed');
    }
    return {
      __sfc: true,
      emit: emit,
      handleClose: handleClose,
      SButton: SButton
    };
  }
});